import { CoverTwo, MainCover } from "./Cover";
import { Intro } from "./Intro";
import { ContactCover } from "../ContactForm";
import { QRCode } from "../QrCode";

export default function HomePageContent() {
  return (
    <div>
      <MainCover />
      <Intro />
      <CoverTwo />
      {/* <Gallery /> */}
      <div id="contact">
        <ContactCover />
      </div>
      <QRCode />

    </div>
  );
}
